import Attribute from "./Attribute";

export default class ArrayAttribute extends Attribute {}